import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth";
import api, { formatApiErrorDetail } from "../api";

export default function ChangePassword() {
  const { user, refresh, logout } = useAuth();
  const navigate = useNavigate();
  const [currentPassword, setCurrent] = useState("");
  const [newPassword, setNew] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (newPassword.length < 8) return setError("New password must be at least 8 characters.");
    if (newPassword !== confirm) return setError("New passwords do not match.");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { currentPassword, newPassword });
      const u = await refresh();
      navigate(u && u.role === "promoter" ? "/portal" : "/", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-wrap">
      <form className="login-card" onSubmit={submit} data-testid="change-password-form">
        <h1>Change Password</h1>
        {user?.mustChangePassword && (
          <p className="muted" data-testid="must-change-notice">
            You must set a new password before continuing.
          </p>
        )}
        {error && <div className="alert" data-testid="change-password-error">{error}</div>}
        <label>Current password</label>
        <input type="password" data-testid="current-password" value={currentPassword}
          onChange={(e) => setCurrent(e.target.value)} required />
        <label>New password</label>
        <input type="password" data-testid="new-password" value={newPassword}
          onChange={(e) => setNew(e.target.value)} required />
        <label>Confirm new password</label>
        <input type="password" data-testid="confirm-password" value={confirm}
          onChange={(e) => setConfirm(e.target.value)} required />
        <button className="btn btn-primary" type="submit" data-testid="change-password-submit" disabled={busy}>
          {busy ? "Saving…" : "Update password"}
        </button>
        <button type="button" className="btn btn-ghost" data-testid="change-password-logout"
          onClick={async () => { await logout(); navigate("/login", { replace: true }); }}>
          Logout
        </button>
      </form>
    </div>
  );
}
